import React from "react";
import { DialogContent, Stack, SvgIcon, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import { CustomDialog, CustomDialogTitle } from "../../ui";
import { clubhouseVerifiedBadgeExplanatoryPoints } from "../../constants";

const Points = styled("ul")({
  padding: "0px",
  margin: "0px 16px",
});

const VerifiedBadgeInfoDialog = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: (e: any) => void;
}) => {
  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <CustomDialogTitle onClose={onClose}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          width="100%"
        >
          <Typography
            color="white"
            variant="subtitle1"
            textAlign="center"
            sx={{
              backgroundColor: "#4267B2",
              px: 1.5,
              py: 0.3,
              borderRadius: 2,
              cursor: "pointer",
              fontWeight: 600,
            }}
            onMouseDown={(e) => e.stopPropagation()}
          >
            cxo
          </Typography>
        </Stack>
      </CustomDialogTitle>
      <DialogContent>
        <Typography variant="h6">
          leap.club cxo&apos;s get special privileges
        </Typography>
        <Points>
          {clubhouseVerifiedBadgeExplanatoryPoints.map((point, index) => {
            return (
              <li key={index}>
                <Typography variant="caption">{point}</Typography>
              </li>
            );
          })}
        </Points>
      </DialogContent>
    </CustomDialog>
  );
};

export default VerifiedBadgeInfoDialog;
